<template>
  <div class="container" id="category-edit1">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    </div>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div class="show-category" title="展示" v-show="categoryId && categoryId.length !== 0">
        <span style="color: #2d46ee">已选择：</span>
        <el-cascader :options="categoryList" v-model="categoryId" :disabled="true" separator=" > "></el-cascader>
      </div>
      <el-cascader-panel :options="categoryList" v-model="categoryId" style="width: 954px">
      </el-cascader-panel>
      <div class="step" style="text-align: left; padding: 0px 0px">
        <el-button type="warning" :disabled="categoryId && categoryId.length !== 1 ? false : true"
          @click="checkUpAttrDataList('inflowShopAdd', categoryId, 'category')">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable
  },
  data() {
    return {
      searchForm: {},
      categoryList: [], // 目类列表
      categoryId: '', // 所选 类目 id
      selectionId: [], // 选 中 id
      parArray: [],// 按钮权限
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品列表', path: '', type: '1' },
          { title: '商品分类', path: '', type: '2' }
        ]
      },
      searchList: {
        list: [
          { title: '商品分类', path: '', type: '0' },
          { title: '选择商品分类', path: '', type: '1' }
        ]
      },
    }
  },
  mounted() { },
  created() {
    this.getCategoryList() // 获取 目类 列表
    // 获取字典值
    // for (let type in this.dictionaries) { this.getDictionaries(type) }
  },
  methods: {
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
      console.log(this.parArray)
    },
    // 获取类目列表
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        categoryName: '',
        categoryNo: '',
        status: 'A'
      }
      this.axios.get('/goods/categoryPageList', {
        params: data

      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryList = res.data.list
          }
        })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      this.categoryId = val
      console.log(this.categoryId)
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 获取 检查 类目商品属性库列表 并 还原 展示 商品属性 表单
    checkUpAttrDataList(name, parameter, type) {
      // console.log(name, parameter, type)
      this.toOtherPages(name, parameter, type)
    },
    // 页面跳转
    toOtherPages(name, parameter, type) {
      let query = { id: parameter, type }
      if (type === 'category') { query = { category: parameter, type } }
      this.$router.push({ name, query })
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee !important;
  font-weight: 700;
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner {
  color: #2d46ee !important;
  font-weight: 400 !important;
}

/* 被选中时的颜色 */
.el-breadcrumb__item:last-child ::v-deep .el-breadcrumb__inner {
  color: #2d46ee !important;
  font-weight: 400 !important;
}

.step {
  margin-top: 38px;
  text-align: center;

  .el-button {
    font-size: 18px;
    width: 184px;
    height: 40px;
    border-radius: 4px;
    background-color: #FF9226;
    border-radius: 3px;
  }
}

.show-category {
  width: 944px;
  font-size: 14px;
  height: 48px;
  line-height: 48px;
  padding-left: 12px;
  // padding-right: 12px;
  background-color: #E9ECFE;
  margin-bottom: 18px;

  ::v-deep .el-cascader {
    width: 80%;

    .el-input {
      input {
        background-color: rgba(0, 0, 0, 0);
        border: none;
        color: #2D46EE;
        cursor: auto;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }
}

.show-category1 {
  width: 98%;
  font-size: 14px;
  height: 48px;
  line-height: 48px;
  padding-left: 12px;
  // padding-right: 12px;
  background-color: #E9ECFE;
  margin-bottom: 18px;

  .el-cascader {
    width: 80%;

    .el-input {
      input {
        background-color: rgba(0, 0, 0, 0);
        border: none;
        color: #2D46EE;
        cursor: auto;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }
}

::v-deep .el-cascader-panel {
  .el-cascader-menu {
    .el-cascader-menu__wrap {
      height: auto;

      .el-cascader-menu__list {
        padding: 0;

        li {
          height: 50px;
          line-height: 50px;
        }

        .in-active-path {
          background-color: #f1f6ff;
        }
      }
    }

    &:nth-child(3) {
      width: 100%;

      .el-cascader-menu__list {
        li {
          background-color: rgba(0, 0, 0, 0);
          float: left;

          .el-icon-check {
            display: none;
          }

          .el-cascader-node__label {
            min-width: 80px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            border-radius: 4px;
          }
        }

        .is-active {
          .el-cascader-node__label {
            color: #ffffff;
            background-color: #2D46EE;
          }
        }
      }
    }
  }
}

::v-deep .el-cascader-panel .el-cascader-menu {
  .el-cascader-menu__wrap .el-scrollbar__wrap {
    // width: 700px;
  }

  .el-cascader-menu__wrap {
    height: auto;

    // width: 234px;
    .el-scrollbar__wrap {
      background: red !important;
    }

    .el-cascader-node {
      // padding: 0px 0px;
    }

    .el-cascader-menu__list .in-active-path {
      background-color: #e9ecfe !important;

      .el-cascader-node__postfix {
        position: absolute;
        right: 10px;
        color: #2d46ee;
        padding: 0px 0px;
      }
    }
  }
}
</style>
